export const AVAILABLE_LANGUAGES = ['nl', 'en', 'de', 'fr-FR', 'pt-PT'] as const;

export type LanguageCode = (typeof AVAILABLE_LANGUAGES)[number];

export const isValidLanguageCode = (code: string): code is LanguageCode => {
  return AVAILABLE_LANGUAGES.includes(code as LanguageCode);
};
